import React from 'react';
import CardExportImport from './viewComponents/card_exportimport';

// ###### MAIN COMPONENT
const TabTravelSettings = ({ trips, fetchTrips }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Settings</h2>

      {/* Export and Import */}
      <CardExportImport trips={trips} fetchTrips={fetchTrips} />
    </div>
  );
};

export default TabTravelSettings;